import { createContext, type FC, type PropsWithChildren, useContext, useState } from "react";

export type SelectedPersonContext = {
	selectedPersonIndex: number;
	setSelectedPerson: (index: number) => void;
};

const SelectedPersonContext = createContext<SelectedPersonContext>({
	selectedPersonIndex: 0,
} as SelectedPersonContext);



export const useSelectedPerson = () => useContext(SelectedPersonContext);

export const SelectedPersonContextProvider: FC<PropsWithChildren> = ({
	children,
}) => {
	const [index, setIndex] = useState(0);
	return (
		<SelectedPersonContext.Provider
			value={{ selectedPersonIndex: index, setSelectedPerson: setIndex }}
		>
			{children}
		</SelectedPersonContext.Provider>
	);
};
